import React, { Fragment, useState, useEffect } from "react";
// import { Dropdown } from 'react-bootstrap';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  headerAction,
  sidebarAction,
  doorlockListAction,
  bookingListAction,
  staffListAction,
  reportListAction,
  // hotelListAction
} from "../stores/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faBuilding,
  faUnlockAlt,
  faPollH,
  faHome,
  faAngleLeft,
  faAngleRight,
  faCog,
  // faAngleDown,
  // faPlusCircle,
  // faClock,
  faCalendarAlt,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";
import HotelCreate from "./views/hotels/HotelCreate";
import * as api from "../api";

const Sidebar = ({ history, refresh }) => {
  // const [ selectedHotelId, setSelectedHotelId ] = useState(localStorage.getItem('hotel_id') || '');
  const { t } = useTranslation();
  const [isOpenHotelCreateModal, setIsOpenHotelCreateModal] = useState(false);
  const {
    isClickedMenuButton,
    isHoverMenu,
    hotelName,
    // timezone,
    address,
    buildingCount,
    roomCount,
    // doorlockCount,
    // bookingCount,
    // staffCount,
  } = useSelector((state) => state.sidebar);
  // const { hotelListItems } = useSelector(state => state.hotelList);
  const dispatch = useDispatch();

  const openMenu = () => {
    dispatch(sidebarAction.setIsHoverMenu(true));
  };

  const closeMenu = () => {
    dispatch(sidebarAction.setIsHoverMenu(false));
  };

  const toggleButton = () => {
    dispatch(sidebarAction.setIsClickedMenuButton(!isClickedMenuButton));
  };

  const setClassName = (path) => {
    return window.location.pathname.split("/")[1] === path
      ? "sidebar-item active"
      : "sidebar-item";
  };

  const moveToHome = () => {
    return history.push("/home");
  };

  const moveToHotelDetail = () => {
    return history.push(`/hotel/${localStorage.getItem("hotel_id")}`);
  };

  const moveToDoorlockList = () => {
    dispatch(doorlockListAction.initDoorlockListState());
    return history.push("/doorlock");
  };

  const moveToDoorlockTileList = () => {
    dispatch(doorlockListAction.initDoorlockListState());
    return history.push("/doorlockTile");
  };

  const moveToBookingList = () => {
    dispatch(bookingListAction.initBookingListState());
    return history.push("/booking");
  };

  const moveToStaffList = () => {
    dispatch(staffListAction.initStaffListState());
    return history.push("/staff");
  };

  const moveToReportList = () => {
    dispatch(reportListAction.initReportListState());
    return history.push("/report");
  };

  const changeHotel = (hotelId) => {
    // setSelectedHotelId(hotelId);
    localStorage.setItem("hotel_id", hotelId);
    changeSidebarItem();
    refresh();
  };

  const changeSidebarItem = async () => {
    try {
      const hotel = await api.selectHotel();
      // const doorlock = await api.listDoorlock({});
      // const booking = await api.listBooking({});
      // const staff = await api.listStaff({});
      dispatch(
        headerAction.setHeaderItem({
          role: hotel.data.role,
        })
      );
      dispatch(
        sidebarAction.setSidebarItem({
          hotelName: hotel.data.name,
          timezone: hotel.data.timezone,
          address: hotel.data.address,
          buildingCount: hotel.data.building_counts,
          roomCount: hotel.data.room_counts,
          // doorlockCount: doorlock.data.total,
          // bookingCount: booking.data.total,
          // staffCount: staff.data.total,
        })
      );
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    const listHotelApi = async () => {
      const res = await api.listHotel({});
      if (!localStorage.getItem("hotel_id")) changeHotel(res.data.items[0].id);
    };
    listHotelApi();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <Fragment>
      <div
        className={`sidebar ${
          isClickedMenuButton ? "" : isHoverMenu ? "view" : "close"
        }`}
      >
        <div className="h-100" onMouseOver={openMenu} onMouseLeave={closeMenu}>
          <div className="hotel-list-box">
            <p className="fixed-item">{hotelName || "-"}</p>
            {/* <Dropdown onClick={e => e.stopPropagation()}>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                <p className='selected-item'>{hotelName || '-'}</p>
                <FontAwesomeIcon icon={faAngleDown}/>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <div className='hotel-info'>
                  {hotelListItems.map((hotel, index) => (
                    <div key={index} className={`dropdown-item-${selectedHotelId === hotel.id ? 'selected':'select'}`} onClick={() => changeHotel(hotel.id)}>
                      <Dropdown.Item href='#'>{hotel.name}</Dropdown.Item>
                    </div>
                  ))}
                </div>
                <div className='pt-8'>
                  <div className='dropdown-item-select active' onClick={() => setIsOpenHotelCreateModal(true)}>
                    <FontAwesomeIcon icon={faPlusCircle}/><span>PROPERTY</span>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown> */}
            {/* <p className='selected-sub-item'>
              <FontAwesomeIcon icon={faClock}/><span>{timezone || '-'}</span>
            </p> */}
            <p className="selected-sub-item">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                style={{ padding: "0 16px 0 1px" }}
              />
              <span>{address || "-"}</span>
            </p>
            <p className="selected-sub-item">
              <FontAwesomeIcon
                icon={faBuilding}
                style={{ padding: "0 15px 0 0" }}
              />
              <span>{`${buildingCount || "0"} ${t(
                "description.building_count"
              )} [ ${roomCount || "0"} ${t("description.room_count")} ]`}</span>
            </p>
          </div>
          <div className="sidebar-item-box">
            <div className={setClassName("home")} onClick={() => moveToHome()}>
              <p>
                <FontAwesomeIcon
                  icon={faHome}
                  style={{ paddingRight: "11px" }}
                />
                <span>{t("sidebar_column.home")}</span>
              </p>
            </div>
            {/* <div className='sidebar-item-title'>
              <p>Settings</p>
            </div> */}
            <div
              className={setClassName("hotel")}
              onClick={() => moveToHotelDetail()}
            >
              <p>
                <FontAwesomeIcon
                  icon={faCog}
                  style={{ paddingRight: "13px" }}
                />
                <span>{t("sidebar_column.hotel")}</span>
              </p>
            </div>
            <div
              className={setClassName("doorlock")}
              onClick={() => moveToDoorlockList()}
            >
              <p>
                <FontAwesomeIcon icon={faUnlockAlt} />
                <span>{t("sidebar_column.doorlock")}</span>
              </p>
              {/* <span>{doorlockCount}</span> */}
            </div>

            <div
              className={setClassName("doorlockTile")}
              onClick={() => moveToDoorlockTileList()}
            >
              <p>
                <FontAwesomeIcon icon={faUnlockAlt} />
                <span>{t("sidebar_column.doorlockTile")}</span>
              </p>
            </div>

            <div
              className={setClassName("booking")}
              onClick={() => moveToBookingList()}
            >
              <p>
                <FontAwesomeIcon icon={faCalendarAlt} />
                <span>{t("sidebar_column.booking")}</span>
              </p>
            </div>
            {/* <div className={setClassName('booking')} onClick={() => moveToPage('/booking')}>
              <p><FontAwesomeIcon icon={faCalendarAlt}/>Booking</p>
              <span>{bookingCount}</span>
            </div> */}
            <div
              className={setClassName("staff")}
              onClick={() => moveToStaffList()}
            >
              <p>
                <FontAwesomeIcon
                  icon={faUserAlt}
                  style={{ paddingRight: "13px" }}
                />
                <span>{t("sidebar_column.staff")}</span>
              </p>
            </div>
            {/* <div className='sidebar-item-title'>
              <p>Analytics</p>
            </div> */}
            <div
              className={setClassName("report")}
              onClick={() => moveToReportList()}
            >
              <p>
                <FontAwesomeIcon icon={faPollH} />
                <span>{t("sidebar_column.report")}</span>
              </p>
            </div>
          </div>
        </div>
        <div className="sidebar-button" onClick={toggleButton}>
          {isHoverMenu || isClickedMenuButton ? (
            <FontAwesomeIcon icon={faAngleLeft} />
          ) : (
            <FontAwesomeIcon icon={faAngleRight} />
          )}
        </div>
      </div>
      <HotelCreate
        isOpen={isOpenHotelCreateModal}
        toggle={() => setIsOpenHotelCreateModal(!isOpenHotelCreateModal)}
        reload={(hotelId) => changeHotel(hotelId)}
      />
    </Fragment>
  );
};

export default Sidebar;
